import SelfServiceTable from "./SelfServiceTable";

export default SelfServiceTable;
